import { render, staticRenderFns } from "./user-permissions.html?vue&type=template&id=578ae92a&scoped=true&"
import script from "./user-permissions.js?vue&type=script&lang=js&"
export * from "./user-permissions.js?vue&type=script&lang=js&"
import style0 from "./user-permissions.scss?vue&type=style&index=0&id=578ae92a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578ae92a",
  null
  
)

export default component.exports